import axios from "axios";
import { Base_URL as API_URL, Base_URL_AiScore as AI_API_URL, Base_URL } from "./apiURL";

axios.defaults.withCredentials = true;

export async function GetAllMocktest(pteType) {
  const config = {
    method: "get",
    url: API_URL + "/app/users/mock-tests/",
    params: {
      core: pteType,
    },
  }; 

  try {
    const response = await axios(config);
    if (response.data.responseCode === 200) {
      return { data: response.data.response };
    } else {
      throw new Error("Error: " + response.data.responseCode);
    }
  } catch (error) {
    console.error("Error fetching mock tests:", error);
    return { error: error.message };
  }
}

export async function GetSectionTests(mock_test_type_id, pteType) {
  const config = {
    method: "get",
    url: API_URL + "/app/users/mock-tests/",
    params: {
      core: pteType,
      mock_test_type_id,
    },
  };

  try {
    const response = await axios(config);
    if (response.data.responseCode === 200) {
      return { data: response.data.response };
    } else {
      throw new Error("Error: " + response.data.responseCode);
    }
  } catch (error) {
    console.error("Error fetching section tests:", error);
    return { error: error.message };
  }
}

export async function GetAllMocktestQuestion({ id }) {
  const config = {
    method: "get",
    url: API_URL + "/app/users/mock-test-questions/get?mock_test_id=" + id,
  };

  return axios(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function GetPendingMocktestQuestion({ id }) {
  const config = {
    method: "get",
    url:
      API_URL +
      "/app/users/mock-test-questions/get-pending-questions?mock_test_attempted_id=" +
      id,
  };

  return axios(config)
    .then((response) => {
      if (response.data.responseCode == 200) {
        return response.data;
      } else {
        return { error: "Some error occured!:" + response.data.responseCode };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function GetMocktestQuestion(id) {
  const config = {
    method: "get",
    url:
      API_URL +
      "/app/users/mock-test-questions/get-question-with-options?question_id=" +
      id,
  };

  return axios(config)
    .then((response) => {
      if (response.data.responseCode == 200) {
        return { data: response.data.response };
      } else {
        return { error: "Some error occured!:" + response.data.responseCode };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

// export async function MakeQuestionAttempted(dt) {

//   const config = {
//     method: "post",
//     url: API_URL + "/app/users/mock-attempted-questions/add",
//     data: dt,
//   };

//   return axios(config)
//     .then((response) => {
//       if (response.data.responseCode == 200) {
//         return { data: response.data.response };
//       } else {
//         return { error: "Some error occured!:" + response.data.responseCode };
//       }
//     })
//     .catch((error) => {
//       console.log(error);

//       return { error: "Some error occured!:" + error };
//     });
// }

const PROCESS_TEST_RETRY_DELAYS_MS = [1000, 2000];

const wait = (delayMs) =>
  new Promise((resolve) => {
    setTimeout(resolve, delayMs);
  });

const getProcessTestErrorMessage = (error) => {
  if (error.response) {
    return `Server error: ${error.response.status} - ${error.response.data.message || error.response.data.error || 'Unknown error'}`;
  }

  if (error.request) {
    return "Network error: No response from server";
  }

  return "Request error: " + error.message;
};

export async function MakeQuestionAttempted(formData) {
  const config = {
    method: "post",
    url: `${Base_URL}/app/queue/process-test`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  for (let attempt = 0; attempt <= PROCESS_TEST_RETRY_DELAYS_MS.length; attempt += 1) {
    try {
      const response = await axios(config);
      if (response.status === 200 || response.data.success) {
        return { data: response.data };
      }

      return { error: "Some error occurred: " + (response.data.message || response.status) };
    } catch (error) {
      const status = error.response?.status;
      const shouldRetry = status === 503 && attempt < PROCESS_TEST_RETRY_DELAYS_MS.length;

      if (shouldRetry) {
        await wait(PROCESS_TEST_RETRY_DELAYS_MS[attempt]);
        continue;
      }

      return { error: getProcessTestErrorMessage(error) };
    }
  }

  return { error: "Server error: 503 - Queue service is still starting" };
}

// Report AI scoring failure for a specific question / attempt
export async function reportAiScoringIssue(payload) {
  const config = {
    method: "post",
    url: API_URL + "/app/users/report-ai-scoring-error",
    data: payload,
  };

  try {
    const response = await axios(config);
    if (response.data.responseCode === 200) {
      return { data: response.data.response };
    } else {
      return { error: response.data.message || "Unknown error" };
    }
  } catch (error) {
    console.error("Error reporting AI scoring issue:", error);
    return { error: error.message };
  }
}

export async function Essay(dt) {
  const config = {
    method: "post",
    url: AI_API_URL + "/essay",
    headers: {
      "Content-Type": "application/json",
    },
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function Summary(dt) {
  const config = {
    method: "post",
    url: AI_API_URL + "/summary",
    headers: {
      "Content-Type": "application/json",
    },
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function SummarizeSpoken(dt) {
  const config = {
    method: "post",
    url: AI_API_URL + "/summarizespoken",
    headers: {
      "Content-Type": "application/json",
    },
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function WriteDictation(dt) {
  const config = {
    method: "post",
    url: AI_API_URL + "/write_dictation",
    headers: {
      "Content-Type": "application/json",
    },
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function Email(dt) {
  const config = {
    method: "post",
    url: AI_API_URL + "/email",
    headers: {
      "Content-Type": "application/json",
    },
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function DescribeImage(data) {
  let dt = new FormData();
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          dt.append(key + "[]", value[i]);
        }
      } else {
        dt.append(key, value);
      }
    }
  }
  const config = {
    method: "post",
    url: AI_API_URL + "/describeimage",
    // headers: {
    //   "Content-Type": "application/json",
    // },
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function RetellLecture(data) {
  let dt = new FormData();
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          dt.append(key + "[]", value[i]);
        }
      } else {
        dt.append(key, value);
      }
    }
  }
  const config = {
    method: "post",
    url: AI_API_URL + "/retellecture",
    // headers: {
    //   "Content-Type": "application/json",
    // },
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function SummarizeGroupDiscussion(data) {
  let dt = new FormData();
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          dt.append(key + "[]", value[i]);
        }
      } else {
        dt.append(key, value);
      }
    }
  }
  const config = {
    method: "post",
    url: AI_API_URL + "/summarize_group_discussion",
    // headers: {
    //   "Content-Type": "application/json",
    // },
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function RespondToSituation(data) {
  let dt = new FormData();
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          dt.append(key + "[]", value[i]);
        }
      } else {
        dt.append(key, value);
      }
    }
  }
  const config = {
    method: "post",
    url: AI_API_URL + "/respondtosituation",
    // headers: {
    //   "Content-Type": "application/json",
    // },
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function RepeatSentence(data) {
  let dt = new FormData();
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          dt.append(key + "[]", value[i]);
        }
      } else {
        dt.append(key, value);
      }
    }
  }
  const config = {
    method: "post",
    url: AI_API_URL + "/repeatsentence",
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function ReadAloud(data) {
  let dt = new FormData();
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          dt.append(key + "[]", value[i]);
        }
      } else {
        dt.append(key, value);
      }
    }
  }
  const config = {
    method: "post",
    url: AI_API_URL + "/readaloud",
    data: dt,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function AnswerShortQuestion(data) {
  const config = {
    method: "post",
    url: AI_API_URL + "/answershortquestions",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
    withCredentials: false,
  };

  return axios(config)
    .then((response) => {
      if (response.data) {
        return { data: response.data };
      } else {
        return { error: "Some error occured!:" + response.data };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function EndTest(dt) {
  const endTimeISO = dt && dt.end_time ? dt.end_time : new Date().toISOString();
  const config = {
    method: "put",
    url:
      API_URL +
      "/app/users/mock-test-attempts/update?mock_test_attempt_id=" +
      dt.mock_test_attempt_id +
      "&end_time=" +
      encodeURIComponent(endTimeISO),
  };

  return axios(config)
    .then((response) => {
      if (response.data.responseCode == 200) {
        return { data: response.data.response };
      } else {
        return { error: "Some error occured!:" + response.data.responseCode };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

export async function Timeout(dt) {
  const config = {
    method: "post",
    url: API_URL + "/app/users/mock-attempted-questions/add-timeout",
    headers: {
      "Content-Type": "application/json",
    },
    data: dt,
  };

  return axios(config)
    .then((response) => {
      if (response.data.responseCode == 200) {
        return { data: response.data.response };
      } else {
        return { error: "Some error occured!:" + response.data.responseCode };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + response.data };
    });
}

export async function GetMockTestProcessingStatus(mock_test_attempted_id) {
  const config = {
    method: "get",
    url:
      API_URL +
      "/app/users/mock-test-attempts/processing-status?mock_test_attempted_id=" +
      mock_test_attempted_id,
  };

  return axios(config)
    .then((response) => {
      if (response.data.responseCode == 200) {
        return { data: response.data.response };
      } else {
        return { error: "Some error occured!:" + response.data.responseCode };
      }
    })
    .catch((error) => {
      console.log(error);

      return { error: "Some error occured!:" + error };
    });
}

/**
 * Gets a signed URL for uploading audio files
 * @returns {Promise<Object>} Response data containing the signed URL or error
 */
export async function getSignedURL() {
  const config = {
    method: "get",
    url: `${Base_URL}/app/users/mock-attempted-questions/signed-url`,
  };
  try {
    const response = await axios(config);
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Error: ${response.status}`);
    }
  } catch (error) {
    console.error("Error getting signed URL:", error);
    return { error: error.message };
  }
}

/**
 * Uploads an audio file to the provided signed URL
 * @param {string} signedUrl - The signed URL for uploading
 * @param {File} file - The audio file to upload
 * @returns {Promise<boolean>} True if upload successful, false otherwise
 */
export async function uploadAudioFile(signedUrl, file) {
  try {
    const res = await axios.put(signedUrl, file, {
      withCredentials: false,
      headers: {
        "Content-Type": file.type,
      },
    });
    return res.status === 200;
  } catch (error) {
    console.error("Error uploading audio file:", error);
    return false;
  }
}
